<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>{{ $t('SERVICES.SERVICE_MANAGEMENT') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="dialogCreate = true">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('SERVICES.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <item-list @show="show"></item-list>
    </v-sheet>

    <v-dialog v-if="dialogCreate" v-model="dialogCreate" max-width="500px">
      <v-card flat dense>
        <v-card-title
          >{{ $t('SERVICES.LIST_HEADER') }}

          <v-spacer></v-spacer>
          <v-btn icon @click="dialogCreate = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="pb-3">{{
          $t('SERVICES.LIST_SUBHEADER')
        }}</v-card-subtitle>
        <v-card-text
          ><types-list @close="dialogCreate = !dialogCreate"> </types-list
        ></v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ServicesLayout',

  components: {
    TypesList: () =>
      import('@/modules/services/components/ServiceTypesList.vue'),
    ItemList: () => import('@/modules/services/components/ServicesList.vue')
  },

  data: () => ({
    dialogCreate: false,
    dialogEdit: false,
    dialogDelete: false,

    service: {}
  }),

  methods: {
    show(item) {
      if (item.type_id === 2) {
        this.$router.push({
          name: 'customer-service.show',
          params: { id: item.id }
        });
      } else if (item.type_id === 3) {
        this.$router.push({
          name: 'internal-service.show',
          params: { id: item.id }
        });
      }
    },

    refreshServices() {
      this.$store.dispatch('service/retrieveServices').then(({ data }) => {
        this.$store.commit('service/retrievedServices', data);
      });
    }
  }
};
</script>
